import React from 'react';
import ServiceLog from './ServiceLog';
import http from 'utils/http';
import moment from 'moment';
import cookies from 'utils/cookies';
import events from 'utils/evemts';

const contractTypes = cookies.get('contract_types') && cookies.get('contract_types') !== 'null' && cookies.get('contract_types').length>0 ? cookies.get('contract_types').sort() : [];
const Role = cookies.get('role');

class ServiceLogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      billingExists: false,
      contract_Type: contractTypes[0] || null,
      airlines: [],
      combinationAirline: [],
      airline: null,
      airlineCode: null,
      role: Role === 'Airline Rep' ? 'air_rep' :'accountant',
      logType: 'DAY',
      search: {
        from: moment().startOf('month').format('YYYY-MM-DD'), 
        to: moment().endOf('month').format('YYYY-MM-DD'),
      },
      filter: { showCompleted: false },
      anchorEl: null,
      ids: [],
      modalslog: null,
      selectedOption: 'not_ok',
      remark: '',
      records: [],
      logColumnHead: [],
      showCompleted: false,
    };
    this.eventSource = null;
    this.billingCheckId = 0;
  }

  componentDidMount() {
    Promise.resolve(this.getFilters()).then(() => {
      this.fetchAirlines();
    });
    this.eventSource = events('service_log');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.action == 'update_service_log' || msg.action == 'add_service_log') {
        const records = [...this.state.records];
        const index = records.findIndex(r => msg.data && r.id == msg.data.id);
        if (index > -1) {
          records[index] = {
            ...records[index],
            ...msg.data,
            log: msg.data.log || records[index].log,
          };
          this.setState({ records }, () => {
            this.filterData();
          });
        }

        if (this.state.modalslog && this.state.modalslog.id == msg.data?.id) {
          this.setState({
            modalslog: {
              ...this.state.modalslog,
              ...msg.data,
              log: msg.data.log || this.state.modalslog.log,
            }
          });
        }
      }
    };
  }

  componentWillUnmount() {
    this.eventSource.close();
  }

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        if(this.state.airline && this.state.airlineCode){
          this.setState({ airlines: response.data.data }, () => { 
            // this.getList();
            this.fetchAirlineCombination();
          });
        } else {
          this.setState({
            airlines: response.data.data,
            airline: response.data.data[0].id,
            airlineCode: response.data.data[0].code
          }, () => { 
            this.storeFilters();
            // this.getList();
            this.fetchAirlineCombination();
          });
        }
      });
  };
  fetchAirlineCombination = () => {
    http.get('/airline_combination?type=all')
      .then((response) => {
        const { data } = response;
        this.setState({ combinationAirline: data.data },()=>{
          this.getList(); 
        });
      });
  };

  checkBillingExists = async () => {
    const checkId = ++this.billingCheckId;
    this.setState({ billingExists: false });
    const { search, airline, contract_Type } = this.state;
    if (!search.from || !airline || !contract_Type) {
      return false;
    }
    const { data } = await http.get('/contract/billing_exists', {
      params: {
        month: moment(search.from).format('YYYY_MM'),
        airlineIds: airline,
        type: contract_Type
      }
    });
    if (data?.status !== 'success' || typeof data.data !== 'boolean') {
      throw new Error('Invalid billing exists response: expected a boolean');
    }
    if (checkId !== this.billingCheckId) {
      return false;
    }
    this.setState({ billingExists: data.data });
    return data.data;
  };

  getList = async () => {
    this.setState({
      records: [],
      list: [],
      ids: [],
      logColumnHead: [],
    });
    try {
      if (!await this.checkBillingExists()) {
        return;
      }
    } catch (error) {
      console.error('Error checking billing exists:', error);
      return;
    }
    const checkId = this.billingCheckId;
    return http.get(`/approval/service_log?from=${this.state.search.from}&to=${this.state.search.to}&contract=${this.state.contract_Type}`).then((response) => {
      if (checkId !== this.billingCheckId) {
        return;
      }
      this.setState({ 
        records: response.data.data,
        list: []
      },()=>{ this.filterData(); });
    });
  };

  getIds = (id) => Array.isArray(id) ? id : [id];

  isCombinationAirline = (airlineIds) => {
    return typeof this.state.airline === 'string' && airlineIds.length > 1 && this.state.combinationAirline.some((combination) => {
      const combinationAirlineIds = (combination.airlineIds || []).map((id) => parseInt(id));
      return airlineIds.every((id) => combinationAirlineIds.includes(id));
    });
  };

  mergeCombinationLogs = (logs) => {
    const groupedLogs = logs.reduce((acc, row) => {
      const date = moment(row.date).format('YYYY-MM-DD');
      acc[date] = acc[date] ? [...acc[date], row] : [row];
      return acc;
    }, {});

    return Object.values(groupedLogs).map((rows) => {
      return rows.reduce((acc, row) => {
        return {
          ...acc,
          ...row,
          id: acc.id ? [...this.getIds(acc.id), row.id] : [row.id],
          date: acc.date || row.date,
          data: acc.data && acc.data.length > 0 ? acc.data : row.data,
          notes: acc.notes && acc.notes.length > 0 ? acc.notes : row.notes,
          log: acc.log && acc.log.length > 0 ? acc.log : row.log,
          docs: acc.docs && acc.docs.length > 0 ? acc.docs : row.docs,
          status: acc.status || row.status,
        };
      }, {});
    });
  };

  filterData = () =>{
    let data = this.state.records;
    let logColumnHead = [];
    //filter by airline
    console.log('this.state.airline___________________________', this.state.airline);
    let airlineIds = [];
    if(typeof this.state.airline === 'string'){
      airlineIds = this.state.airline.split(',').map(id => parseInt(id));
    } else {
      airlineIds = [this.state.airline];
    }
    // let filteredData = data.filter((item) => {
    //   return item.airlineId  === this.state.airline;
    // });
    let filteredData = data.filter((item) => {
      return airlineIds.includes(item.airlineId);
    });
    //filter by role 
    filteredData = filteredData.filter((item) => {
      if(!this.state.showCompleted){
        if(this.state.role === 'accountant'){
          return ((item.status === 'Finalized' && item.approved_acc === false) || (item.status === 'Rejected' && !item.approved_acc === false && item.approved_air === false));
        } else if(this.state.role === 'air_rep'){
          return (item.status === 'Pending' && item.approved_air === false);
        }
      } else {
        //return only completed logs
        if(this.state.role === 'accountant'){
          return ((item.status === 'Pending' && item.approved_acc === true && item.approved_air === false)
          || item.status === 'Approved'
          || (item.status === 'Rejected' && item.rejected_acc === true));
        } else if(this.state.role === 'air_rep'){
          return ((item.status === 'Approved' && item.approved_air === true) || (item.status === 'Rejected' && item.rejected_air === true));
        }
      }
    });
    //filter by logType
    filteredData = filteredData.filter((item) => {
      return item.type === this.state.logType;
    });
    if(this.isCombinationAirline(airlineIds)){
      filteredData = this.mergeCombinationLogs(filteredData);
    }
    // sort by date
    filteredData.sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    });
    // get column names
    filteredData.forEach((item) => {
      if(item.data && item.data.length > 0){
        item?.data && item?.data?.forEach((d) => {
          if(!logColumnHead.includes(d.label)) {
            logColumnHead.push(d.label);
          }
        });
      }
    });
    this.setState({ 
      list: filteredData,
      logColumnHead,
      ids: []
    });
  };

  UpdateServiceLog = () => {
    let ids = [];
    let option = this.state.selectedOption;
    if(this.state.modalslog){
      ids = this.getIds(this.state.modalslog.id);
    } else {
      // get all selected ids
      ids = this.state.ids;
    }
    let data = {
      ids: ids,
      status: option === 'comment' ? 'Comment' : option === 'ok' ? 'Approved' : 'Rejected',
      remark: this.state.remark,
    };
    http.put('/service_log', data).then(() => {
      if (option !== 'comment' && !this.state.showCompleted) {
        const records = this.state.records.filter(r => !ids.includes(r.id));
        this.setState({
          records,
          ids: [] 
        }, () => {
          this.filterData();
        });
      } else {
        this.setState({ ids: [] });
      }
      this.handleReviewClose();
    });
  };

  selectAll = (flag) => {
    if(flag){
      let ids = this.state.list.map((item) => this.getIds(item.id)).flat();
      this.setState({ ids: ids });
    } else {
      this.setState({ ids: [] });
    }
  };
   
  selectServiceLog = (id, flag)=>{
    console.log('selectServiceLog', id, flag);
    let selectedIds = this.getIds(id);
    if(flag){
      this.setState({ ids: [...new Set([...this.state.ids, ...selectedIds])] });
    } else {
      let filtered = this.state.ids.filter((item) => !selectedIds.includes(item));
      this.setState({ ids: filtered });
    }
  };

  selectOption = (value) => {
    this.setState({ selectedOption: value });
  };

  setRemark = (value) => {
    this.setState({ remark: value });
  };

  onChangeSearch = (e) => {
    if(e.target.name === 'month'){
      let from = moment(e.target.value).startOf('month').format('YYYY-MM-DD');
      let to = moment(e.target.value).endOf('month').format('YYYY-MM-DD');
      this.setState({
        search: {
          ...this.state.search,
          from: from,
          to: to
        }
      },()=>{
        this.storeFilters();
        this.getList();
      });
    } else {
      this.setState({
        search: {
          ...this.state.search,
          [e.target.name]: e.target.value
        }
      },()=>{
        this.storeFilters();
        this.getList();
      });
    }
  };


  filterList = () => {
    let list = this.state.list;
    return list;
  };

  handleContractType = (e) => {
    this.setState({ contract_Type: e.target.value, },()=>{
      this.storeFilters();
      this.getList();
    });
  };
  
  handleAirlineChange = (e) => {
    let value = e.target.value;
    console.log('handleAirlineChange', value);
    console.log('typeof value', typeof value);
    let airline = null;
    let airlineCode = null;
    if( typeof value === 'number'){
      airline = this.state.airlines.find(airline => airline.id === value).id;
      airlineCode = this.state.airlines.find(airline => airline.id === value).code;
    } else if (typeof value === 'string'){
      // value has string value of  1,28
      // combination.airlineIds has value of [1,28]
      let airlineIds = value.split(',').map(id => parseInt(id));
      let combination = this.state.combinationAirline.find(combination => airlineIds.every(id => combination.airlineIds.includes(id)));
      if(combination){
        airline = value;
        airlineCode = combination.airlines.map(airline => airline.code).join(',');
        console.log('combination', combination);
        console.log('airline', airline);
        console.log('airlineCode', airlineCode);
      }
    }
    this.setState({
      airline: airline,
      airlineCode: airlineCode,
    },()=>{
      this.storeFilters();
      this.getList();
    });
  };
  handleRoleChange = (e) => {
    this.setState({ role: e.target.value },()=>{
      this.storeFilters();
      this.filterData(); 
    });
  };
  handleLogTypeChange = (e) => {
    this.setState({ logType: e.target.value },()=>{ this.filterData(); });
  };

  handleReview = (anchorEl, serviceLog) => {
    console.log('handleReview', serviceLog);
    this.setState({ 
      anchorEl,
      modalslog: serviceLog
    });
  };

  handleReviewClose = () => {
    this.setState({ 
      anchorEl: null,
      modalslog: null,
      selectedOption: null,
      remark: '',
    });
  };

  storeFilters = () => {
    console.log('storeFilters');
    let filters = {
      search: this.state.search,
      contract_Type: this.state.contract_Type,
      airline: this.state.airline,
      airlineCode: this.state.airlineCode,
      role: this.state.role,
    };
    // set expiry got 1 day.
    cookies.set('approvals', filters, { 
      path: '/', 
      maxAge: 86400 
    });
  };
  getFilters = () => {
    console.log('getFilters');
    let filters = cookies.get('approvals');
    if (filters) {
      if(filters.search){
        this.setState({ search: filters.search });
      }
      if(filters.contract_Type){
        this.setState({ contract_Type: filters.contract_Type });
      }
      if(filters.airline){
        this.setState({ airline: filters.airline });
      }
      if(filters.airlineCode){
        this.setState({ airlineCode: filters.airlineCode });
      }
      if(filters.role){
        this.setState({ role: filters.role });
      }
    }
  };

  render() {
    return (
      <>  
        <ServiceLog
          billingExists={this.state.billingExists}
          list={this.state.list}
          contract_Type= {this.state.contract_Type}
          airlines= {this.state.airlines}
          airline= {this.state.airline}
          airlineCode= {this.state.airlineCode}
          combinationAirline={this.state.combinationAirline}
          search={this.state.search} 
          filter={this.state.filter}
          role={this.state.role}
          ids={this.state.ids}
          logType={this.state.logType}
          handleLogTypeChange={this.handleLogTypeChange}
          modalslog={this.state.modalslog}
          selectedOption={this.state.selectedOption}
          remark={this.state.remark}
          records={this.state.records}
          selectServiceLog={this.selectServiceLog}
          selectOption={this.selectOption}
          setRemark={this.setRemark}
          filterList={this.filterList}
          handleRoleChange={this.handleRoleChange}
          handleReviewClose={this.handleReviewClose}
          onChangeSearch={this.onChangeSearch} 
          onChangeFilter={this.onChangeFilter} 
          anchorEl={this.state.anchorEl}
          handleReview={this.handleReview}
          handleAirlineChange={this.handleAirlineChange}
          UpdateServiceLog={this.UpdateServiceLog}
          selectAll={this.selectAll}
          handleContractType={this.handleContractType}
          logColumnHead={this.state.logColumnHead}
          showCompleted={this.state.showCompleted}
          handleShowCompleted={() => this.setState({ showCompleted: !this.state.showCompleted }, () => {
            //filter data after toggling showCompleted
            this.selectAll(false);
            this.filterData();
          })}
        />
      </>
    );
  }
}

export default ServiceLogContainer;

